export default [
  'icon-old',
  'icon-line',
  'icon-solid',
  'icon-filled-line',
]